import { Component, Input } from '@angular/core';
import { AdvisorWidgetData } from './domain/model/advisor-widget.model';

@Component({
    selector: 'ifbp-advisor-widget',
    templateUrl: './advisor-widget.component.html',
    styleUrls: ['./advisor-widget.component.scss'],
    standalone: false
})
export class AdvisorWidgetComponent {
  @Input()
  data: AdvisorWidgetData;

  /** The dashboard block asks for Figma's `add_ic_call`; the Contact Us popover keeps this default. */
  @Input()
  callIconName = 'phone_in_talk';

  openCalendarUrl(): void {
    window.open(this.data?.calendarUrl, "_blank");
  }
}
